/* Documents Client barrel export */

import { IDocumentFoldersClient, IDocumentsClient } from './IDocumentsClient';
import { DocumentFoldersClientApi, DocumentsClientApi } from './documentsClientApi';
import { DocumentFoldersClientMocked, DocumentsClientMocked } from './documentsClientMocked';

// Re-export types
export * from './documentsTypes';
export * from './IDocumentsClient';

/* ---- Configuration ---- */

import { shouldUseMockedClient } from '../../environment';

/**
 * Determines whether to use mocked clients.
 * Automatically uses mocked clients on localhost and ofstest5 environments.
 */
const isMockedEnvironment = () => shouldUseMockedClient();

/* ---- Factory Functions ---- */

let foldersClientInstance: IDocumentFoldersClient | null = null;
let documentsClientInstance: IDocumentsClient | null = null;

/**
 * Get the DocumentFoldersClient instance.
 * Automatically uses mocked data on localhost and ofstest5 environments.
 */
export function getDocumentFoldersClient(): IDocumentFoldersClient {
  if (foldersClientInstance) {
    return foldersClientInstance;
  }

  if (isMockedEnvironment()) {
    foldersClientInstance = new DocumentFoldersClientMocked();
  } else {
    foldersClientInstance = new DocumentFoldersClientApi();
  }
  return foldersClientInstance;
}

/**
 * Get the DocumentsClient instance.
 * Automatically uses mocked data on localhost and ofstest5 environments.
 */
export function getDocumentsClient(): IDocumentsClient {
  if (documentsClientInstance) {
    return documentsClientInstance;
  }

  if (isMockedEnvironment()) {
    documentsClientInstance = new DocumentsClientMocked();
  } else {
    documentsClientInstance = new DocumentsClientApi();
  }
  return documentsClientInstance;
}

/**
 * Reset the client instances (useful for testing).
 */
export function resetDocumentsClients(): void {
  foldersClientInstance = null;
  documentsClientInstance = null;
}

/* ---- Backwards Compatibility ---- */

/**
 * @deprecated Use getDocumentFoldersClient() instead
 */
export class DocumentFoldersClient extends DocumentFoldersClientMocked {}

/**
 * @deprecated Use getDocumentsClient() instead
 */
export class DocumentsClient extends DocumentsClientMocked {}
